<template>
  <div class="bg-dark w-100">
    <div>Summary</div>
    <div>Analisis produk</div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
